import React from "react";
import { Helmet } from "react-helmet";
import Banner from "../../../component/Banner";
import image1 from "../../../images/manufacturing/manufacturing1.webp";
import { Link } from "react-router-dom";
const Automotive = () => {
  const banner = {
    title: "Automotive",
    image: image1,
  };

  return (
    <>
      <Helmet>
        <title>
        Automotive — Cylon Technologies – Big Data | Data Analytics | Digital Strategy
        </title>
      </Helmet>
      <Banner heading={banner.title} bannerimg={banner.image} />
      <section className="sec-padd page_content heading_space pb-5 small_ul">
        <div className="container">
          <div className="row g-md-5 g-4 justify-content-between">
            <div className="col-md-7">
              <h2 className="heading2">Digital Automotive Solutions </h2>
              <p>
              Automotive manufacturers and their partners are facing key challenges in the face of technological and competitive factors playing a crucial role in the manufacturing of innovative products in the automobile industry. The ever changing consumer preferences, tightening regulations driven by new trends are also encouraging new players to enter the automotive market with innovative products and services. In addition, to enhance the driving experience for all end users or customers, the automotive industry is embracing the disruptively changing technology in the market.
              </p>
              <p>
              Cylon Technologies is a strategic partner to the global automotive industry providing world-class technology, services and solutions for improving efficiency, reducing costs thereby helping our multinational clients gaining maximum benefits from their global assets. We offer a wide range of automotive solutions and technologies for the evolution of the next generation automobiles.
              </p>
              <p>
              With automotive sector successfully adopting emerging technologies such as mobility, social media, telematics and analytics there is a need for them to have a strategic partner who works hand in hand in boosting their efficiency and innovation for their operations across the globe.  Cylon Technologies has emerged as the global leader for your core manufacturing and supply chain processes in the connected vehicle market. Cylon Technologies Connected Services (CTCS) is driving digital transformation in the connected world for industries and enterprises of all sizes.
              </p>
              <p>
              Cylon Technologies is enabling automakers, auto suppliers and fleet owners in developing, deploying, and in managing secure and reliable connected vehicle services. Our capabilities in the field of automotive solutions include-
              </p>
              <h2 className="heading2">Connected Vehicle Solutions-  </h2>
              <p>
              With the need for developing more advanced in-vehicle technologies is creating competitive challenges for the automobile industry in the connected vehicle market. The rapid range of technologies is also offering potential opportunities for gaining competitive advantage as such Cylon Technologies offers services and solutions that help in defining a connected vehicle strategy, integrate range of technologies (V2V, V2I, and V2X), providing embedded software development for in vehicle electronics, building data analytics and accelerating the product development cycle. The Cylon Technologies Connected Vehicle Solutions provides onboard and connectivity solutions that covers applications in vehicle diagnostics, mobile integration, safety, passenger comfort and fuel efficiency.
              </p>



            </div>
            <div className="col-md-4">
              <div className="right_content">
                <div className="border-tb mb-5">
                  <h2 className="heading2 mt-0">Offerings</h2>
                  <p>
                  Cylon Technologies automotive specific portfolio in the form of IT technology and solutions in areas such as user interface design, mobility, social media, IoT and analytics in order to develop various Digital Automotive applications targeted specifically at new age consumers.  With the automotive industry fast catching up with consumer electronics industry in terms of lifestyle and application as such our digital automotive solutions are designed to bridge this gap.  Our expertise in providing digital automotive solutions encompasses car owners to solutions for vehicles and consumer device integration in the form of following services such as-
                  </p>
                  <ul>
                    <li>Vehicle Drive Integration</li>
                    <li>
                    Vehicle Quality Management
                    </li>
                    <li>
                    Automotive Social Media Tracking and Reporting
                    </li>
                    <li>Dealer Incentive Management</li>
                    <li>Enterprise Integration</li>
                    <li>Systems Integration</li>
                    <li>Connected  Supply Chain</li>

                  </ul>
                  <p>
                  Cylon Technologies is well renowned for having expertise in all industry leading ERP and SCM packages that is helping our automotive clients in developing an enterprise system strategy, re-engineering business processes and in implementing large scale enterprise wide programs. We also have expertise in integrating back to back enterprise systems with business applications such as transportation and warehouse management systems.
                  </p>
                  <p>For more information on our Automotive Solutions – <Link to="/connect">Contact</Link></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Automotive;
